import { render } from "./addNewProviderModal.vue?vue&type=template&id=6554c14d&scoped=true&ts=true"
import script from "./addNewProviderModal.vue?vue&type=script&lang=ts"
export * from "./addNewProviderModal.vue?vue&type=script&lang=ts"

import "./addNewProviderModal.vue?vue&type=style&index=0&id=6554c14d&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6554c14d"]])

export default __exports__